import React from 'react';

export default function ConfirmModal({ confirmTitle, confirmSubtitle, onClose, onConfirm }) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-30">
      <div className="bg-white rounded-xl p-6 max-w-sm w-full text-center space-y-4 m-8">
        <h2 className="text-xl font-bold">{confirmTitle}</h2>
        <p className="text-sm text-gray-600">{confirmSubtitle}</p>
        <div className="flex justify-between space-x-4">
          <button
            className="flex-1 bg-gray-300 text-gray-700 py-2 rounded-lg font-medium"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="flex-1 bg-blue-600 text-white py-2 rounded-lg font-medium"
            onClick={onConfirm}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
}
